import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyDUnQNkz3xteKVpktcd-tFKlGeECZNRAE8",
  authDomain: "helius-wellness-chat.firebaseapp.com",
  databaseURL: "https://helius-wellness-chat-default-rtdb.firebaseio.com",
  projectId: "helius-wellness-chat",
  storageBucket: "helius-wellness-chat.firebasestorage.app",
  messagingSenderId: "55679862528",
  appId: "1:55679862528:web:ad0b2d595efda14478d5e5",
  measurementId: "G-JN0L0L9BQ6"
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app) 